import { render, staticRenderFns } from "./TitleList.vue?vue&type=template&id=20fbf6d0&scoped=true"
import script from "./TitleList.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitleList.vue?vue&type=style&index=0&id=20fbf6d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fbf6d0",
  null
  
)

export default component.exports